import { observer } from 'mobx-react-lite'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import {
  PrintAuditNotesButton,
  PrintAuditReportButton,
  PrintDeviationsButton
} from '@cdab/scania/qpr/components/atoms'
import type { AuditModel } from '@cdab/scania/qpr/offline/models'

import { useFeatures } from '@cdab/scania/qpr/feature-flags'
import { capitalizeFirstLetter } from '@cdab/utils'
import { AuditReportModal } from '../audit-report-modal'
import { AuditActions } from './audit-actions'
import { ActionsSection, Header, StyledTdsButton } from './audit-summary.styles'

export const ActionsBlocks = observer(
  ({ audit, className }: { audit: AuditModel; className?: string }) => {
    const { t } = useTranslation(['common', 'reports'])
    const { dos_5_report } = useFeatures(['dos_5_report'])
    const auditReportModalRef = useRef<HTMLTdsModalElement>(null)

    const hasDeviations = audit.deviations.some(
      deviation =>
        !deviation.deviationWithoutActions && deviation.approvalDate == null
    )

    const openModal = () => {
      auditReportModalRef.current?.showModal()
    }

    return (
      <>
        <div style={{ width: '100%' }} className={className}>
          <AuditActions
            dealerId={audit.did}
            auditId={audit.id}
            canCertify={!audit.isReadonly}
            hasDeviations={hasDeviations}
            isCertified={audit.isCertified}
          />
          <div className='tds-mode-variant-primary tds-u-mt3 tds-u-w100 tds-u-p2'>
            <Header>{capitalizeFirstLetter(t('reports'))}</Header>
            <ActionsSection>
              <PrintAuditReportButton audit={audit} />

              <PrintDeviationsButton audit={audit} />
              <PrintAuditNotesButton audit={audit} />
            </ActionsSection>
            {dos_5_report.enabled && (
              <div className='tds-u-flex-dir-col tds-u-w100 tds-u-mt3'>
                <StyledTdsButton
                  onClick={openModal}
                  text={capitalizeFirstLetter(
                    t('audit-dos-report', { ns: 'reports' })
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <AuditReportModal ref={auditReportModalRef} auditId={audit.id} />
      </>
    )
  }
)
